define('TescoMobile_Iovation/js/action/get-device-fingerprint',['../iovation'], function () {
  'use strict';

  return function () {
    if (!window.IGLOO) {
      return null;
    }
    const _window$IGLOO$getBlac = window.IGLOO.getBlackbox(),
      finished = _window$IGLOO$getBlac.finished,
      blackbox = _window$IGLOO$getBlac.blackbox;
    return finished ? blackbox : null;
  };
});

